// Array di immagini ottimizzate per l'hero
export const heroImages = [
  '/img/HERO/1.webp',
  '/img/HERO/2.webp',
  '/img/HERO/3.webp',
  '/img/HERO/4.webp',
  '/img/HERO/5.webp',
  '/img/HERO/6.webp',
  '/img/HERO/7.webp',
  '/img/HERO/8.webp',
  '/img/HERO/9.webp',
  '/img/HERO/10.webp',
  '/img/HERO/11.webp',
];

// Funzione per ottenere un'immagine casuale dall'array
export const getRandomHeroImage = (): string => {
  const randomIndex = Math.floor(Math.random() * heroImages.length);
  return heroImages[randomIndex];
};

// Funzione per ottenere tutte le immagini dell'hero
export const getAllHeroImages = (): string[] => {
  return heroImages;
};
